<template>
  <div class="activity-join-rank">
    <div class="activity-join-rank-top">
        <div class="title">备课活动参与榜top5</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="activity-join-rank-table">
        <el-row class="top" type="flex">
            <el-col style="text-align: center" :span="4">排名</el-col>
            <el-col style="text-align: center" :span="4">教师</el-col>
            <el-col style="text-align: center" :span="4">主备数</el-col>
            <el-col style="text-align: center" :span="6">协备数</el-col>
            <el-col style="text-align: center" :span="6">教研成果数</el-col>
        </el-row>
        <el-row class="content" type="flex" v-for="item in activityList" :key="item.schoolId">
            <el-col style="text-align: center" :span="4" class="school-name">{{ item.rank }}</el-col>
            <el-col style="text-align: center" :span="4" class="school-name">{{ item.name }}</el-col>
            <el-col style="text-align: center" :span="4">{{ item.number }}</el-col>
            <el-col style="text-align: center" :span="6">{{ item.assisNumber }}</el-col>
            <el-col style="text-align: center" :span="6">{{ item.resultNumber }}</el-col>
        </el-row>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
        activityList:[
            {
                rank:1,
                name:"赵范",
                number:56,
                assisNumber:10,
                resultNumber:15
            },
            {
                rank:2,
                name:"王明",
                number:50,
                assisNumber:10,
                resultNumber:14
            },
            {
                rank:3,
                name:"刘小锋",
                number:45,
                assisNumber:8,
                resultNumber:13
            },
            {
                rank:4,
                name:" 张继德",
                number:46,
                assisNumber:6,
                resultNumber:12
            },
            {
                rank:5,
                name:"朱志英",
                number:40,
                assisNumber:8,
                resultNumber:11
            }
        ]
    }
  },
  methods: {

  },
  mounted(){

  }
}
</script>
<style lang='scss' scoped>
.activity-join-rank{
    width: 100%;
    height: 270px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .activity-join-rank-top{
        position: relative;
        text-align: center;
        margin-bottom: 18px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .activity-join-rank-table{
        .top{
            background-color: rgba(16, 34, 67, 0.5);
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #708ACC;
        }
        .content{
            background-color: rgba(16, 34, 67, 0.5);
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #A1B6EB;
            .school-name{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>